import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { getSingle, deleteOne } from '../../../modules/appointment'
import DialogCOmponent from './dialog'
import View from './view'
import { setAlert } from '../../../flux/alert'
import adminHoc from '../../hoc/admin'

const ApointmentDetail = props => {
  const [isDialoOpen, setDialogOpen] = useState(false)
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const hisotry = useHistory()
  const dispatch = useDispatch()

  const { id } = useParams()

  const handleRedirect = event => {
    hisotry.push('/admin-appointment')
  }

  const fetcher = async () => {
    setLoading(true)
    const data = await getSingle(id)
    if (!data) return handleRedirect()
    setData(data)
    setLoading(false)
  }

  useEffect(() => {
    fetcher()
  }, [])

  const handleDelete = () => {
    dispatch(setAlert({
      title: 'Eliminar cita',
      message: '¿Seguro quieres eliminar esta cita?',
      textAction: 'Eliminar',
      action: async () => {
        await deleteOne(id)
        handleRedirect()
      }
    }))
  }

  return (
    <>
      <DialogCOmponent
        open={isDialoOpen}
        onClose={event => setDialogOpen(false)}
        callback={fetcher}
        id={id}
      />
      <View
        loading={loading}
        onOpenChangePaidStatus={() => setDialogOpen(true)}
        data={data}
        onDelete={handleDelete}
        {...data}
      />
    </>
  )
}

export default adminHoc(ApointmentDetail)
